module.exports = __webpack_public_path__ + "img/sunny-king-logo.cecc1926.jpg";